export const getSessionStorage = () => {
  try {
    return sessionStorage;
  } catch {
    // e.g. SSR / restricted iframe
    return undefined;
  }
};

export const getLocalStorage = () => {
  try {
    return localStorage;
  } catch {
    // e.g. SSR / restricted iframe
    return undefined;
  }
};

const getKey = (prefix: string, key: string) => `${prefix}${key}`;

export const loadFromStorageKeyPrefix = (key: string, prefix: string, storage: any | undefined) => {
  if (!storage) return undefined;
  const value = storage.getItem(getKey(prefix, key));
  if (value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      console.error(`Failed to parse ${prefix}${key} from storage`, e);
    }
  }
  return undefined;
};

export const persistSectionPrefixed = (prefix: string, section: Record<string, any>, storage: any | undefined) => {
  Object.entries(section).forEach(([key, value]) => {
    const storageKey = getKey(prefix, key);
    if (value !== undefined && value !== null) {
      storage?.setItem(storageKey, JSON.stringify(value));
    } else {
      storage?.removeItem(storageKey);
    }
  });
};

export const persistEntryPrefixed = (prefix: string, key: string, value: any, storage: any | undefined) => {
  const storageKey = getKey(prefix, key);
  if (value !== undefined && value !== null) {
    storage?.setItem(storageKey, JSON.stringify(value));
  } else {
    storage?.removeItem(storageKey);
  }
};